import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { InputTextarea, ModalForm, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { clockDateParts } from "@helpers/timeClock";

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

/**
 * Confirmação da batida, com observação opcional. O horário gravado é o do
 * servidor (o back só aceita a observação).
 *
 * Props: onClose, onSaved.
 */
export default function ClockModal({ onClose, onSaved }) {
  const timeClockService = useService("timeClock");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  function close() {
    if (!saving) onClose();
  }

  async function save() {
    setSaving(true);
    const result = await timeClockService.clock(note.trim());
    setSaving(false);
    // Em erro, o sendError do service já mostrou o toast; o modal continua aberto
    if (!result || result.error) return;
    const { time } = clockDateParts(result.data?.clocked_at);
    toast.success(time ? `Ponto registrado às ${time}` : "Ponto registrado!");
    onSaved();
  }

  return (
    <ModalForm
      $showModal
      $setShowModal={close}
      $noClose={saving}
      $isLoading={saving}
      $size="medium"
      $title="Registrar ponto"
      $contentBackground="N0"
      $actions={[
        { text: "Cancelar", action: close, variant: "outline", isDisabled: saving },
        { text: "Registrar ponto", action: save, variant: "primary", isDisabled: saving },
      ]}>
      <Stack>
        <Text
          $text="A batida é gravada agora, com o horário do servidor, não o do seu dispositivo."
          $variant="paragraph_small_medium"
          $color="N700"
        />
        <InputTextarea
          $idForm="clock-note"
          $label="Observação"
          $variant="default"
          placeholder="Ex.: saída para consulta médica"
          rows={2}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </Stack>
    </ModalForm>
  );
}
